<template>
  <div style="padding:10px;" v-if="calendarData != null">
    <calendar v-model="date" v-bind="calendarData"/>
    <cancelaccept @accept="accept" @cancel="cancel" />
  </div>
</template>

<script>
import calendar from '../Calendar/Calendar.vue'
import cancelaccept from '../CancelAccept/CancelAccept.vue'

export default {
  components: {
    calendar,
    cancelaccept
  },
  data () {
    return {
      date: null
    }
  },
  computed: {
    calendarData () {
      return this.$store.state.calendarWidget
    }
  },
  methods: {
    async accept () {
      if (this.date.year != null && this.date.month != null &&
        this.date.day != null) {
        this.$store.commit('addToContext', {'_input': this.date})
        await this.$store.dispatch('sendMessage',
          {message: `${this.date.year}/${this.date.month}/${this.date.day}`})
      }
    },
    async cancel () {
      this.$store.commit('addToContext', {'_input': false})
      await this.$store.dispatch('sendMessage', {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/CalendarWidget/CalendarWidget.vue